function SvgTaxes({ color = "#111928", width = 20, height = 20, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.90625 11.25H8.625C9 11.25 9.3125 10.9375 9.3125 10.5625C9.3125 10.1875 9 9.875 8.625 9.875H4.90625C4.53125 9.875 4.21875 10.1875 4.21875 10.5625C4.21875 10.9375 4.5 11.25 4.90625 11.25Z"
        fill={color || color}
      />
      <path
        d="M4.90625 14.125H9.34375C9.71875 14.125 10.0625 13.8125 10.0625 13.4375C10.0625 13.0625 9.75 12.75 9.34375 12.75H4.90625C4.53125 12.75 4.21875 13.0625 4.21875 13.4375C4.21875 13.8125 4.5 14.125 4.90625 14.125Z"
        fill={color || color}
      />
      <path
        d="M10.75 17.5625H3.46875C3.3125 17.5625 3.1875 17.4375 3.1875 17.2812V2.09375C3.1875 1.9375 3.3125 1.8125 3.46875 1.8125H8.03125V5.9375C8.03125 6.84375 8.78125 7.59375 9.6875 7.59375H14.25V10.8438C14.25 11.2188 14.5625 11.5313 14.9375 11.5313C15.3125 11.5313 15.625 11.2188 15.625 10.8438V7.25C15.625 6.8125 15.4375 6.375 15.0937 6.0625L9.625 0.875C9.3125 0.59375 8.90625 0.40625 8.46875 0.40625H3.46875C2.53125 0.40625 1.78125 1.15625 1.78125 2.09375V17.3125C1.78125 18.25 2.53125 19 3.46875 19H10.7812C11.1562 19 11.4687 18.6875 11.4687 18.3125C11.4687 17.9375 11.1562 17.5625 10.75 17.5625ZM13.2187 6.1875H9.6875C9.53125 6.1875 9.4375 6.09375 9.4375 5.9375V2.625L13.2187 6.1875Z"
        fill={color || color}
      />
      <path
        d="M13.3125 14.0938C13.744 14.0938 14.0938 13.744 14.0938 13.3125C14.0938 12.881 13.744 12.5312 13.3125 12.5312C12.881 12.5312 12.5312 12.881 12.5312 13.3125C12.5312 13.744 12.881 14.0938 13.3125 14.0938Z"
        fill={color || color}
      />
      <path
        d="M16.4688 17.0938C16.0312 17.0938 15.6875 17.4375 15.6875 17.875C15.6875 18.3125 16.0312 18.6562 16.4688 18.6562C16.9062 18.6562 17.25 18.3125 17.25 17.875C17.25 17.4375 16.9062 17.0938 16.4688 17.0938Z"
        fill={color || color}
      />
      <path
        d="M17.5625 12.8125C17.2813 12.5312 16.8438 12.5312 16.5625 12.8125L12.375 17C12.0937 17.2813 12.0937 17.7187 12.375 18C12.5 18.125 12.6875 18.2187 12.875 18.2187C13.0625 18.2187 13.25 18.1562 13.375 18L17.5938 13.7812C17.8438 13.5312 17.8438 13.0937 17.5625 12.8125Z"
        fill={color || color}
      />
    </svg>
  );
}

export default SvgTaxes;
